import { UntypedFormControl } from '@angular/forms';

export interface ValidationResult {
  [key: string]: boolean;
}

export class PasswordValidator {
  static checkLength(control: UntypedFormControl): any {
    if (control.value && typeof control.value != 'undefined') {
      const hasMinLength = control.value.length > 5;
      const hasNumber = /\d/.test(control.value);
      const hasUpper = /[A-Z]/.test(control.value);
      const hasLower = /[a-z]/.test(control.value);
      // console.log('Num, Upp, Low, Length', hasNumber, hasUpper, hasLower, hasMinLength);
      const valid = hasNumber && hasUpper && hasLower && hasMinLength;
      if (!valid) {
        // return what´s not valid
        return { strong: true };
      }
      return null;
    }
    return null;
  }

  static strong(control: UntypedFormControl): ValidationResult | null {
    const hasNumber = /\d/.test(control.value);
    const hasUpper = /[A-Z]/.test(control.value);
    const hasLower = /[a-z]/.test(control.value);
    const hasCharacter = /[!@#$%^&/=*(),.?":{}|<>]/.test(control.value);
    // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
    const valid = hasNumber && hasUpper && hasLower && hasCharacter;
    if (!valid) {
      // return what´s not valid
      return { strong: true };
    }
    return null;
  }
}
